import type { PadelStandingItem } from '@/services/padelService';
import PadelPlayerAvatar from './PadelPlayerAvatar';
import { padelShortName } from './padelUiUtils';

interface PadelPodiumProps {
  top: PadelStandingItem[];
}

interface PodiumSlotProps {
  item?: PadelStandingItem;
  rank: 1 | 2 | 3;
}

const slotConfig = {
  1: {
    avatar: 'h-16 w-16 text-xl ring-4 ring-[#FBBF24]',
    base: 'h-16 bg-[#FEF3C7]',
    point: 'text-2xl text-[#B45309]',
    badge: 'bg-[#FBBF24] text-white',
    order: 'order-2',
  },
  2: {
    avatar: 'h-12 w-12 text-base ring-4 ring-gray-300',
    base: 'h-10 bg-[#E5E7EB]',
    point: 'text-lg text-gray-600',
    badge: 'bg-gray-400 text-white',
    order: 'order-1',
  },
  3: {
    avatar: 'h-12 w-12 text-base ring-4 ring-[#FDBA74]',
    base: 'h-8 bg-[#FFE4D5]',
    point: 'text-lg text-[#C2410C]',
    badge: 'bg-[#FB923C] text-white',
    order: 'order-3',
  },
} as const;

function PodiumSlot({ item, rank }: PodiumSlotProps) {
  const cfg = slotConfig[rank];
  if (!item) {
    return <div className={`flex-1 ${cfg.order}`} />;
  }
  return (
    <div className={`flex flex-1 flex-col items-center ${cfg.order}`}>
      <p className="mb-1 truncate text-[11px] font-medium text-gray-500">
        {padelShortName(item.playerName)}
      </p>
      <div className="relative">
        <PadelPlayerAvatar
          name={item.playerName}
          avatarUrl={item.avatarUrl}
          colorKey={String(item.participantId)}
          className={cfg.avatar}
        />
        <span
          className={`absolute -bottom-1 left-1/2 -translate-x-1/2 rounded-full px-1.5 text-[10px] font-bold ${cfg.badge}`}
        >
          {rank}
        </span>
      </div>
      <p className={`mt-2 font-extrabold ${cfg.point}`}>{item.pointsScored}</p>
      <div className={`mt-1 w-full rounded-t-md ${cfg.base}`} />
    </div>
  );
}

export default function PadelPodium({ top }: PadelPodiumProps) {
  return (
    <div className="flex items-end gap-2 px-2">
      <PodiumSlot item={top[1]} rank={2} />
      <PodiumSlot item={top[0]} rank={1} />
      <PodiumSlot item={top[2]} rank={3} />
    </div>
  );
}
